import React from "react";
import Navbar from "../components/navbar/navbar";
import Project from "../components/project/project";
import Footer from "../components/footer/footer";

const MXE: React.FC = () => {


  return (
    <>
      <Navbar/>
      <div className="page-content">
        <Project project="mxe"/>
      </div>
      <Footer />
    </>
  );
};

export default MXE;